import merge from 'lodash.merge';
export default (analytics, ...configs) => {
  analytics && analytics.push(dataLayer => {
    return merge({
      type: 'impression'
    }, ...configs.map(configFn => configFn ? configFn(dataLayer) : {}));
  });
};